// Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextFieldModule } from '@angular/cdk/text-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Components
import { TonteppichRoutingModule } from './tonteppich-routing.module';
import { TonteppichComponent } from './tonteppich.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { ContactComponent } from './components/contact/contact.component';
import { ReferencesComponent } from './components/references/references.component';
import { EquipmentComponent } from './components/equipment/equipment.component';
import { ImprintComponent } from './components/imprint/imprint.component';
import { ImportComponent } from './components/import/import.component';

// Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSortModule } from '@angular/material/sort';

// Libs
import { TranslocoRootModule } from './transloco-root.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { fritzschoff } from '@env/secrets';

@NgModule({
  declarations: [
    TonteppichComponent,
    HeaderComponent,
    HomeComponent,
    ContactComponent,
    ReferencesComponent,
    EquipmentComponent,
    ImprintComponent,
    ImportComponent
  ],
  imports: [
    BrowserModule,
    TonteppichRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TextFieldModule,
    HttpClientModule,

    // Libs
    TranslocoRootModule,
    AngularFireModule.initializeApp(fritzschoff.firebase),
    AngularFirestoreModule,

    // Material
    MatFormFieldModule,
    MatListModule,
    MatInputModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule
  ],
  providers: [],
  bootstrap: [TonteppichComponent]
})
export class TonteppichModule { }
